/* RESPONSIBLE TEAM: team-self-serve */
import ApplicationAdapter from './application';

export default class QuoteAdaptor extends ApplicationAdapter {
  buildURL(_modelName: any, _id: any, _snapshot: any, _requestType: any, _query: any) {
    return '/ember/prices';
  }
}
